import React, { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/site";
import ImageUpload from "../ImageUpload";

const EMPTY = {
  home_about_id: null, home_about_url: "",
  about_page_id: null, about_page_url: "",
  project_fallback_id: null, project_fallback_url: "",
};

const SLOTS = [
  { idKey: "home_about_id", urlKey: "home_about_url", label: "Forside – «Om oss»-bilde", hint: "Bildet som vises ved siden av «Om oss»-teksten på forsiden." },
  { idKey: "about_page_id", urlKey: "about_page_url", label: "Om oss-side – hovedbilde", hint: "Stort bilde på Om oss-siden." },
  { idKey: "project_fallback_id", urlKey: "project_fallback_url", label: "Prosjekt – reservebilde", hint: "Vises hvis et prosjekt mangler bilde." },
];

export default function PageImagesSettings() {
  const [value, setValue] = useState(EMPTY);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try { const r = await api.get("/admin/settings/page_images"); setValue({ ...EMPTY, ...(r.data?.value || {}) }); }
      finally { setLoading(false); }
    })();
  }, []);

  const save = async () => {
    setSaving(true);
    try { await api.put("/admin/settings/page_images", { value }); toast.success("Sidebilder lagret"); }
    catch { toast.error("Kunne ikke lagre"); }
    finally { setSaving(false); }
  };

  if (loading) return <div className="p-8 text-center bg-white border rounded-xl"><Loader2 className="animate-spin inline text-[#1B3626]"/></div>;

  return (
    <div className="space-y-5 mt-8 pt-8 border-t border-[#E2DDD5]">
      <div>
        <h2 className="font-display text-lg sm:text-xl font-bold">Sidebilder</h2>
        <p className="text-sm text-[#555E68] mt-1">Bytt ut bilder som brukes på forsiden, «Om oss»-siden og andre plasser på nettstedet.</p>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        {SLOTS.map(slot => {
          const cur = value[slot.idKey] ? { id: value[slot.idKey] } : (value[slot.urlKey] ? { url: value[slot.urlKey] } : null);
          return (
            <div key={slot.idKey} className="rounded-xl bg-white border border-[#E2DDD5] p-4 space-y-3">
              <div>
                <div className="font-semibold text-sm">{slot.label}</div>
                <div className="text-xs text-[#555E68] mt-0.5">{slot.hint}</div>
              </div>
              <ImageUpload
                label="Last opp"
                mode="single"
                scope="pages"
                value={cur}
                onChange={(v) => setValue({ ...value, [slot.idKey]: v?.id || null, [slot.urlKey]: v?.id ? "" : (v?.url || "") })}
              />
              <label className="block">
                <span className="text-[11px] uppercase tracking-wider text-[#555E68]">... eller bilde-URL</span>
                <input
                  value={!value[slot.idKey] ? (value[slot.urlKey] || "") : ""}
                  onChange={(e) => setValue({ ...value, [slot.urlKey]: e.target.value, [slot.idKey]: null })}
                  placeholder="https://..."
                  className="mt-1 w-full rounded-md border border-[#D5D0C7] px-3 py-2 text-xs"
                  data-testid={`pageimg-${slot.urlKey}`}
                />
              </label>
            </div>
          );
        })}
      </div>

      <div className="flex justify-end">
        <button onClick={save} disabled={saving} className="btn-primary" data-testid="pageimg-save">
          {saving ? <Loader2 size={14} className="animate-spin"/> : <Save size={14}/>} Lagre sidebilder
        </button>
      </div>
    </div>
  );
}
